import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, Input, HostListener, Output, EventEmitter } from '@angular/core';
import { FileIconType } from 'app/models/file-icon-type.enum';
import { FileType } from 'app/models/file-type.enum';
import { File } from 'app/models/file';
import { Source } from 'app/models/source.enum';

@Component({
  selector: 'app-asset-tile',
  templateUrl: './asset-tile.component.html',
  styleUrls: ['./asset-tile.component.scss'],
})
export class AssetTileComponent implements OnInit {
  @Input() data: any;
  @Input() showDelete: boolean;
  @Output() delete: EventEmitter<File> = new EventEmitter();
  public hoverState = '';
  public fileIconType: string;

  @HostListener('mouseenter') onMouseEnter() {
    this.hoverState = `hoverOn`;
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.hoverState = `hoverOut`;
  }

  constructor(private router: Router, private activatedRoute: ActivatedRoute) { }

  enumRrverse(enumList, value) {
    const keys = Object.keys(enumList).filter(k => typeof enumList[k as any] === 'string');
    const values = keys.filter(k => enumList[k as any] === value);
    return values[0];
  }

  ngOnInit() {
    this.fileIconType = `icon-${FileIconType[this.enumRrverse(FileType, this.data.contentType)]}`;
  }

  isFile(): Boolean {
    return [Source.Image, Source.Video, Source.PDF, Source.Onboarding, Source.Document]
      .indexOf(this.data.source) !== -1;
  }

  goTo() {
    const id = this.isFile() && this.data.source !== Source.Document ?
               this.data.documentId : this.data.id;
    if(this.data.source === Source.Stadium) {
      this.router.navigate(
        [(this.isFile() ? 'file' : this.data.source.toLowerCase())],
        { relativeTo: this.activatedRoute }
      );
    } else {
      this.router.navigate(
        [(this.isFile() ? 'file' : this.data.source.toLowerCase()), id],
        { relativeTo: this.activatedRoute }
      );
    }
  }

  getFileCount() {
    let result = 0;
    if (this.data.files && !this.isFile()) {
      result = this.data.files.length;
    }
    return (result > 1 ? result + ' DOCUMENTS' : result + ' DOCUMENT');
  }

  onDelete($event) {
    this.delete.emit($event);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/asset-tile/asset-tile.component.ts